<div class="cancellation-dialog">
  @if (loading$ | async) {
    <div
      class="cancellation-dialog__loading"
      [cfaLoading]="true">
    </div>
  }
  @if (error$ | async) {
    <error-message [error]="error$ | async" [page]="'Automation Cancellation Dialog'">
    </error-message>
    <div mat-dialog-actions class="cancellation-dialog__wrapper">
      <button mat-button class= "cancellation-dialog__cancel-button" data-testid="close-button" [disabled]="loading$ | async" (click)="closeDialog()">Close</button>
    </div>
  }
  @if (!(error$ | async) && !(loading$ | async)) {
    @if (title) {
      <div class="cancellation-dialog__title" [innerHTML]=title></div>
    }
    <div class="cancellation-dialog__text" [innerHTML]=displayText></div>
    <div mat-dialog-actions class="cancellation-dialog__wrapper">
      @if (id !== thirdPartyPromotionId) {
        <button mat-button class ="cancellation-dialog__cancel-button" data-testid="cancel-button" (click)="closeDialog()">Cancel</button>
      }
      @if (id === thirdPartyPromotionId) {
        <button mat-button class ="cancellation-dialog__cancel-button" data-testid="cancel-button" (click)="closeDialogAndReturnToDiscover()">Cancel</button>
      }
      @if (id !== communityCareEventId && id !== thirdPartyPromotionId && id !== freeItemInCartId) {
        <button mat-button
          class="cancellation-dialog__send-button" data-testid="stop-automation-button" (click)="cancelAutomation()">
          Stop Automation
        </button>
      }
      @if (id === communityCareEventId) {
        <button mat-button data-testid="stop-event-button" class="cancellation-dialog__send-button"
          (click)="cancelCommunityCareEvent()">
          Stop Event
        </button>
      }
      @if (id === thirdPartyPromotionId) {
        <button mat-button data-testid="stop-promotion-button" class="cancellation-dialog__send-button"
          (click)="cancelThirdPartyPromotion()">
          Stop Promotion
        </button>
      }
      @if (id === freeItemInCartId) {
        <button mat-button data-testid="stop-promotion-button" class="cancellation-dialog__send-button"
          (click)="cancelFreeInCart()">
          Stop Promotion
        </button>
      }
    </div>
  }
</div>
